export function useDssApiRequestComposable() {
  // Loading state
  const isLoading = ref(false)
  const hasError = ref(false)
  const isEdit = ref(false)
  // Methods to toggle loading state
  const startLoading = () => {
    isLoading.value = true
  }

  const stopLoading = () => {
    isLoading.value = false
  }

  // Methods to toggle error state
  const triggerError = () => {
    hasError.value = true
  }

  const clearError = () => {
    hasError.value = false
  }

  // Methods to toggle error state
  const editMode = () => {
    isEdit.value = true
  }

  const createMode = () => {
    isEdit.value = false
  }

  const isEditMode = () => {
    return isEdit.value
  }
  const executeRequest = async (apiCalls) => {
    try {
      startLoading()
      clearError()

      // Return the responses for further processing
      return await Promise.all(apiCalls)
    }
    catch (error) {
      triggerError()
      stopLoading()

      // Re-throw the error to allow calling code to handle it
      throw error
    }
    finally {
      stopLoading()
    }
  }

  return {
    isLoading,
    hasError,
    isEditMode,
    editMode,
    createMode,
    startLoading,
    stopLoading,
    triggerError,
    clearError,
    executeRequest,
  }
}
